import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Checkbox from '@narvar/nth-checkbox';
import Divider from '@narvar/nth-divider';

const mapStateToProps = ({
  page: { itemsDisclaimerChecked: checked },
  retailerSettings: { branding: { brand_call_to_action: brandCTAColor } = {} },
  language: {
    'returns.step_1.items_disclaimer_checkbox.header': header = '',
    'returns.step_1.items_disclaimer_checkbox.description': description = '',
  },
}) => ({
  checked,
  brandCTAColor,
  header,
  description,
});

export const ItemsDisclaimerCheckbox = ({
  onChange,
  checked,
  header,
  description,
  brandCTAColor,
}) => (
  <div className="items-disclaimer-checkbox">
    {header && (
      <React.Fragment>
        <h3>{header}</h3>
        <Divider />
      </React.Fragment>
    )}
    <div
      role="button"
      onKeyDown={(e) => {
        if (e.keyCode === 13 || e.keyCode === 32) onChange();
      }}
      tabIndex="0"
    >
      <Checkbox
        id="disclaimer-checkbox"
        checked={checked}
        onChange={onChange}
        boxStyle={{
          width: '1.5rem',
          height: '1.5rem',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: checked ? brandCTAColor : '#b4b4b4',
          background: brandCTAColor,
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </Checkbox>
    </div>
  </div>
);

ItemsDisclaimerCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  header: PropTypes.string,
  description: PropTypes.string,
  brandCTAColor: PropTypes.string,
};

ItemsDisclaimerCheckbox.defaultProps = {
  checked: false,
  onChange: undefined,
  header: '',
  description: '',
  brandCTAColor: '#2b7cac',
};

export default connect(mapStateToProps)(ItemsDisclaimerCheckbox);
